/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsRosterPermissionsDtoSchema } from "./rosterPermissionsDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsRosterCurrentUserContextSchema = z.object({
  isMember: z.optional(z.boolean()),
  isCaptain: z.optional(z.boolean()),
  get permissions() {
    return goodLuckCoreDTOsRosterPermissionsDtoSchema.optional();
  },
});
